import { render, staticRenderFns } from "./MajorShareholdersUs.vue?vue&type=template&id=1431f9bc&scoped=true"
import script from "./MajorShareholdersUs.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersUs.vue?vue&type=script&lang=js"
import style0 from "./MajorShareholdersUs.vue?vue&type=style&index=0&id=1431f9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431f9bc",
  null
  
)

export default component.exports